<template>
  <div class="custom-view-wrapper">
    <div class="dg-content" ></div>
    <div class="dg-content">{{ trans("RepublishOfferConfirmation.title") }}</div>
    <br/>

    <button class="btn btn-default btn-cons m-t-10 m-l-5" @click="noticeToCandidate('all')" :options="options" >{{ trans("RepublishOfferConfirmation.all") }}</button>
    <button class="btn btn-default btn-cons m-t-10 m-l-5" @click="noticeToCandidate('new_concerned_candidate')" :options="options" >
      {{ trans("RepublishOfferConfirmation.new_concerned_candidate") }}
    </button>
    <button class="btn btn-default btn-cons m-t-10 m-l-5" @click="noticeToCandidate('none')" :options="options" >{{ trans("RepublishOfferConfirmation.none") }}</button>
  </div>
</template>

<script>
import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';
import i18n from '@/lang'

export default {
  name: 'RepublishOfferConfirmation',
  mixins: [DialogMixin],
  methods: {
    noticeToCandidate(type) {
      this.proceed(type);
    },
    trans(text){
      return i18n.t(text);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/offers/RepublishOfferConfirmation.vue